import type { ReactNode } from "react";

import { ModalContainer } from "@aviary";

import { container } from "./SignUpModalContainer.styles";

interface Props {
  children: ReactNode;
  isNoPaddingTop?: boolean;
}

const SignUpModalContainer = ({ children }: Props) => {
  return <ModalContainer css={[container]}>{children}</ModalContainer>;
};

export { SignUpModalContainer };
